"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaHome = function FaHome(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M1408 992v480q0 26-19 45t-45 19H960v-384H704v384H320q-26 0-45-19t-19-45V992q0-1 .5-3t.5-3l575-474 575 474q1 2 1 6zm223-69l-62 74q-8 9-21 11h-3q-13 0-21-7L832 424l-692 577q-12 8-24 7-13-2-21-11l-62-74q-8-10-7-23.5T37 878l719-599q32-26 76-26t76 26l244 204V288q0-14 9-23t23-9h192q14 0 23 9t9 23v408l219 182q10 8 11 21.5t-7 23.5z"
  })));
};

FaHome.defaultProps = {
  viewBox: '0 0 1664 1896.083',
  height: '1em',
  width: '0.8776em'
};
FaHome.displayName = 'FaHome';
var _default = FaHome;
exports.default = _default;